import { NodeResponse, RebalancingPlanOperation } from '@cast/types';

type RebalancingPlanOperationCount = {
  total: number;
  completed: number;
  create: number;
  created: number;
  drain: number;
  drained: number;
  delete: number;
  deleted: number;
};

export const aggregateOperations = (
  rebalancePlanOperations: RebalancingPlanOperation[] = []
): RebalancingPlanOperationCount => {
  return rebalancePlanOperations.reduce(
    (
      count: RebalancingPlanOperationCount,
      operation: RebalancingPlanOperation
    ) => {
      if (operation.type === 'create_node') {
        count.total += 1;
        count.create += 1;

        if (operation.finishedAt) {
          count.created += 1;
          count.completed += 1;
        }
      }

      if (operation.type === 'drain_node') {
        count.total += 1;
        count.drain += 1;

        if (operation.finishedAt) {
          count.drained += 1;
          count.completed += 1;
        }
      }

      if (operation.type === 'delete_node') {
        count.total += 1;
        count.delete += 1;

        if (operation.finishedAt) {
          count.deleted += 1;
          count.completed += 1;
        }
      }

      return count;
    },
    {
      total: 0,
      completed: 0,
      create: 0,
      created: 0,
      drain: 0,
      drained: 0,
      delete: 0,
      deleted: 0,
    }
  );
};

export const isNodeFailedToDrain = ({ annotations }: NodeResponse): boolean =>
  !!annotations && annotations['rebalancing.cast.ai/status'] === 'drain-failed';
